import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { LeadFlowVisual } from './LeadFlowVisual';
import { Bloom } from './Bloom';
export function Hero() {
  return <section id="top" className="relative isolate overflow-hidden border-b border-[#1a1a1a]" data-id="element-246" data-mp="9ka2qpx8ocsp">
      <Bloom size="lg" className="left-[-8rem] top-[-12rem]" data-id="element-247" data-mp="4m8m0bnacpke" />
      <div className="pointer-events-none absolute inset-0 opacity-[0.35]" aria-hidden="true" style={{
      backgroundImage: 'linear-gradient(to right, #171717 1px, transparent 1px), linear-gradient(to bottom, #171717 1px, transparent 1px)',
      backgroundSize: '72px 72px',
      maskImage: 'radial-gradient(ellipse 70% 60% at 50% 30%, #000 40%, transparent 100%)',
      WebkitMaskImage: 'radial-gradient(ellipse 70% 60% at 50% 30%, #000 40%, transparent 100%)'
    }} data-id="element-248" data-mp="4jm7fs1z99so" />

      <div className="relative mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-14 px-6 pb-24 pt-20 lg:grid-cols-[1.05fr_0.95fr] lg:gap-8 lg:pb-32 lg:pt-28" data-id="element-249" data-mp="381e3bhj8idw5">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-250" data-mp="3o7c1c19oavi7">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-500" data-id="element-251" data-mp="39cfjqxfz4vsg">
            Phoenix &middot; Home services
          </p>

          <h1 className="mt-6 text-[2.5rem] font-bold leading-[1.05] tracking-tight text-white sm:text-6xl" data-id="element-252" data-mp="30hrgfctylo6a">
            You paid for that lead.
            <br data-id="element-253" data-mp="35a2jgojzxq32" />
            <span className="text-neutral-500" data-id="element-254" data-mp="35akoa9kq5cml">Don&rsquo;t let it go to voicemail.</span>
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-neutral-400" data-id="element-255" data-mp="2viy2jjarfv5l">
            We catch every call, text, and Yelp lead for your business automatically, 24/7, so
            the job gets booked while you&rsquo;re still on the ladder.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-4" data-id="element-256" data-mp="2lk8wqow5215p">
            <CTAButton data-id="element-257" data-mp="s2b7vyavsj55">Book a 15-min call</CTAButton>
            <span className="font-mono text-xs uppercase tracking-[0.15em] text-neutral-600" data-id="element-258" data-mp="s44e5chl11cm">
              Month to month &middot; No contracts
            </span>
          </div>

        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.15
      }} className="order-first lg:order-none" data-id="element-259" data-mp="i9vrh5f8g2md">
          <LeadFlowVisual data-id="element-260" data-mp="161jcj6ptcjgq" />
        </motion.div>
      </div>
    </section>;
}